module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel--bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "activity-content m-t-md"
  }, [(_vm.activity) ? _c('div', [_c('table', [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.computedActivities), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.duration)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.reason)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  }))]), _vm._v(" "), _c('router-link', {
    staticClass: "m-t-md button is-large is-primary is-outlined",
    attrs: {
      "to": "/activity"
    }
  }, [_vm._v("\n                View More\n              ")])], 1) : _c('div', [_c('h3', [_vm._v("Looks like you've never signed in to your team before.")]), _vm._v(" "), _c('h3', [_vm._v("Let's change that by signing in with the button above")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-header m-t-md"
  }, [_c('h4', {
    staticClass: "has-text-centered"
  }, [_vm._v("Latest Activity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Date and Time")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-024ff7a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardHome.vue
// module id = 377
// module chunks = 1